(function () {
  // Simple debounce helper
  const debounce = (fn, ms) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), ms);
    };
  };

  // Core updater: posts to /cart/change.js
  const postQuantity = (input) => {
    let qty = parseInt(input.value, 10);
    if (Number.isNaN(qty) || qty < 0) qty = 0;

    const line = parseInt(input.dataset.line, 10);
    if (!line) return;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line, quantity: qty })
    })
    .then(res => res.json())
    .then(() => {
      // Reload so totals & line prices update (works for cart page or drawer)
      window.location.reload();
    })
    .catch(console.error);
  };

  const debouncedPost = debounce(postQuantity, 400);

  // Update as the user types (debounced)
  document.addEventListener('input', (e) => {
    if (e.target.matches('.QuantitySelector__CurrentQuantity')) {
      debouncedPost(e.target);
    }
  });

  // Ensure update on change/blur
  document.addEventListener('change', (e) => {
    if (e.target.matches('.QuantitySelector__CurrentQuantity')) {
      postQuantity(e.target);
    }
  });

  // Support pressing Enter inside the field
  document.addEventListener('keydown', (e) => {
    if (e.target.matches('.QuantitySelector__CurrentQuantity') && e.key === 'Enter') {
      e.preventDefault();
      postQuantity(e.target);
    }
  });
})();


(function () {
  const BUILDER_SELECTOR = '.css-12579ce.builder-block .css-1qggkls';
  const CART_SELECTOR = '.Header_CartQuan';

  /**
   * Ensure we have at least one .Header_CartQuan.
   * If it doesn't exist and we have somewhere to put it, create it.
   */
  function ensureCartBadgeExists() {
    let badges = document.querySelectorAll(CART_SELECTOR);
    return badges;
  }

  /**
   * Updates all header cart quantity elements
   * Shows if value > 0 (add .is-visible), hides otherwise
   */
  function updateAllHeaderCounts(value) {
    const badges = ensureCartBadgeExists();
    badges.forEach(el => {
      if (value > 0) {
        el.classList.add('is-visible');
        el.textContent = value;
        el.innerHTML = value;
      } else {
        el.classList.remove('is-visible');
        el.textContent = '';
      }
    });
  }

  /**
   * Syncs the header with the builder block number
   */
  function syncCartQuantity(el) {
    const rawText = el.textContent.trim();
    const num = parseInt(rawText, 10);
    if (!isNaN(num)) {
      updateAllHeaderCounts(num);
    }
  }

  /**
   * Observes changes on the builder element
   */
  function observeElement(el) {
    if (!el) return;
    syncCartQuantity(el);
    const innerObserver = new MutationObserver(() => syncCartQuantity(el));
    innerObserver.observe(el, {
      childList: true,
      characterData: true,
      subtree: true
    });

    const parent = el.parentElement;
    if (parent) {
      const parentObserver = new MutationObserver(() => {
        const newEl = document.querySelector(BUILDER_SELECTOR);
        if (newEl && newEl !== el) {
          innerObserver.disconnect();
          parentObserver.disconnect();
          observeElement(newEl);
        }
      });
      parentObserver.observe(parent, { childList: true, subtree: false });
    }
  }

  /**
   * Waits until the builder element exists before attaching
   */
  function waitForElement() {
    const el = document.querySelector(BUILDER_SELECTOR);
    if (el) {
      observeElement(el);
      return;
    }

    // Otherwise, start observing
    const docObserver = new MutationObserver(() => {
      const found = document.querySelector(BUILDER_SELECTOR);
      if (found) {
        docObserver.disconnect();
        observeElement(found);
      }
    });

    // Start observing the DOM for changes
    docObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  waitForElement();
})();